"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function BottomCtaSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-secondary py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block bg-primary text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">
          {t("hood.commonCta")}
        </span>
        <h2 className="text-3xl md:text-[36px] font-black text-white mb-4">
          {t("serviceAreas.bottomH2")}
        </h2>
        <p className="text-base text-[#fefce8] max-w-[720px] mx-auto mb-8 leading-relaxed">
          {t("serviceAreas.bottomSub")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-accent text-white px-7 py-3 text-sm font-bold rounded-md hover:bg-accent/90 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            {t("serviceAreas.bottomCallBtn")}
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-7 py-3 text-sm font-bold rounded-md hover:bg-white hover:text-secondary transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line" />
            </span>
            {t("serviceAreas.bottomEmailBtn")}
          </a>
        </div>

        <p className="text-xs text-[#fefce8]">
          {t("serviceAreas.bottomAddress")}
        </p>
      </div>
    </section>
  );
}